import * as React from "react";

import type { IconProps } from "./types";

export const TargetIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M7.43376 14.6667V13.2019C4.99602 12.9395 3.06075 11.0042 2.79834 8.56645H1.3335C1.02053 8.56645 0.76709 8.313 0.76709 8.00004C0.76709 7.68708 1.02053 7.43363 1.3335 7.43363H2.79834C3.06076 4.99586 4.99596 3.05927 7.43376 2.79692V1.33337C7.43376 1.02041 7.6872 0.766968 8.00016 0.766968C8.31312 0.766968 8.56657 1.02041 8.56657 1.33337V2.79692C11.0044 3.05927 12.9396 4.99586 13.202 7.43363H14.6668C14.9798 7.43363 15.2332 7.68708 15.2332 8.00004C15.2332 8.313 14.9798 8.56645 14.6668 8.56645H13.202C12.9396 11.0042 11.0043 12.9395 8.56657 13.2019V14.6667C8.56657 14.9797 8.31312 15.2331 8.00016 15.2331C7.6872 15.2331 7.43376 14.9797 7.43376 14.6667ZM8.00016 3.89978C5.7358 3.89978 3.8999 5.73567 3.8999 8.00004C3.8999 10.2644 5.7358 12.1003 8.00016 12.1003C10.2645 12.1003 12.1004 10.2644 12.1004 8.00004C12.1004 5.73567 10.2645 3.89978 8.00016 3.89978ZM9.43376 8.00004C9.43376 7.20843 8.79177 6.56645 8.00016 6.56645C7.20855 6.56645 6.56657 7.20843 6.56657 8.00004C6.56657 8.79165 7.20855 9.43363 8.00016 9.43363C8.79177 9.43363 9.43376 8.79165 9.43376 8.00004ZM10.5666 8.00004C10.5666 9.41757 9.41769 10.5664 8.00016 10.5664C6.58263 10.5664 5.43376 9.41757 5.43376 8.00004C5.43376 6.58251 6.58263 5.43363 8.00016 5.43363C9.41769 5.43363 10.5666 6.58251 10.5666 8.00004Z"
        fill={color}
      />
    </svg>
  ),
);

export default TargetIcon;
